module.exports = __webpack_public_path__ + "img/sp-banner-business.aae6eac.png";